export default "__VITE_ASSET__BDJNIPdK__"